import { t } from "@lingui/macro";
import { OpenAI } from "openai";

import { DEFAULT_BASE_URL } from "@/client/constants/llm";
import { useOpenAiStore } from "@/client/stores/openai";

export const openai = () => {
  const { apiKey, baseURL, isAzure, azureApiVersion, model } = useOpenAiStore.getState();

  if (!apiKey) {
    throw new Error(
      t`Your AI API key has not been set yet. Please go to your account settings to enable AI integration.`,
    );
  }

  if (isAzure) {
    if (!baseURL || !model || !azureApiVersion) {
      throw new Error(
        t`Azure OpenAI Base URL, deployment name (model), and API version are required when using Azure OpenAI.`,
      );
    }

    const azureBaseURL = baseURL.replace(/\/$/, "");

    return new OpenAI({
      apiKey,
      baseURL: `${azureBaseURL}/openai/deployments/${model}`,
      defaultQuery: { "api-version": azureApiVersion },
      dangerouslyAllowBrowser: true,
    });
  }

  const resolvedBaseURL = baseURL ?? DEFAULT_BASE_URL;

  return new OpenAI({
    apiKey,
    baseURL: resolvedBaseURL,
    dangerouslyAllowBrowser: true,
  });
};
